export default __webpack_public_path__ + "static/media/third-right.32ddcfac.png";